"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _useWindowResize = _interopRequireDefault(require("@hooks/useWindowResize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Layout = function Layout(_ref) {
  var children = _ref.children;
  var height = (0, _useWindowResize["default"])();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};

var _default = Layout;
exports["default"] = _default;